
import React, { useEffect, useState } from "react";
import { Button, Col, Container, OffcanvasBody, OffcanvasHeader, Row } from "reactstrap";
import { errorHandler } from "utils/Api";
import DefaultOffCanvas from "../DefaultOffCanvas";
import form from 'formConfigs/userAddress';
import DynamicForm from "components/DynamicForm";
import { showAlert } from "utils/Alert";
import styles from "./style.module.scss";
import { saveAddress } from "api/AddressApi";
import { ANALYTIC_EVENT_ACTIONS, ANALYTIC_EVENT_CATEGORIES } from "utils/Constants";
import { trackEvent } from "utils/Analytics";

const AddDeliveryAddressOffCanvas = props => {
    const { btnColor = "primary", className, address, poBox, onSave, onClose } = props;
    const [isOpen, setOpen] = useState(false);
    const [addressData, setAddressData] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const isAddressEdit = address?.id;

    useEffect(() => {
        if (isAddressEdit) {
            setInitialData();
        } else {
            setAddressData({});
        }
    }, [isAddressEdit, address]);

    const setInitialData = () => {
        if (address.id) {
            setOpen(true);
        }
        setAddressData(address);
    }

    const toogleOffCanvas = (newState) => {
        setOpen(newState);
        if (newState == false) {
            onCanvasClosed();
        } else {
            trackEvent(ANALYTIC_EVENT_CATEGORIES.USER, ANALYTIC_EVENT_ACTIONS.OPEN_MODAL, "Perfil: Agregar Direccion para envio")
        }
    }

    const onCanvasClosed = () => {
        setAddressData({});
        setOpen(false);
        if (onClose) {
            onClose();
        }
    }

    const getOffcanvasLabel = () => {
        if (isAddressEdit) {
            return `Modificar Direccion de Entrega`;
        }
        return "Agregar Direccion de Entrega";
    }

    const storeAddress = (formData) => {
        const addressStoreData = {
            poBoxAddressesId: poBox.id,
            ...formData
        }
        setIsLoading(true);
        saveAddress(addressStoreData).then((r) => {
            showAlert("success", "La direccion de entregar se ha creado exitosamente");
            setOpen(false);
            if (onSave) {
                onSave(r);
            }
        }).catch(e => {
            showAlert("danger", "No fue posible guardar la direccion de entrega")
            errorHandler(e, "Crear o modificar direccion de entrega");
        }).finally(e => setIsLoading(false));
    }

    return (
        <>
            {props.children && (<Button
                color={btnColor}
                className={className}
                onClick={() => toogleOffCanvas(!isOpen)}
            >
                {props.children}
            </Button>)
            }
            <DefaultOffCanvas
                direction="end"
                isOpen={isOpen}
                onClosed={onCanvasClosed}
                toggle={() => toogleOffCanvas(!isOpen)}
            >
                <OffcanvasHeader className={styles.offCanvasHeader} toggle={onCanvasClosed}>
                    {getOffcanvasLabel()}
                </OffcanvasHeader>
                <OffcanvasBody className={styles.offCanvasBody}>
                    <Container>
                        <DynamicForm
                            id="addAddress"
                            externalFormState={addressData}
                            formConfig={form}
                            onSubmit={storeAddress}
                            isLoading={isLoading}>
                            <Container>
                                <Row>
                                    <Col>
                                        <Button
                                            className="float-end"
                                            type="submit"
                                            color="success">
                                            Guardar
                                        </Button>
                                    </Col>
                                </Row>
                            </Container>
                        </DynamicForm>
                    </Container>
                </OffcanvasBody>
            </DefaultOffCanvas>
        </>
    );
}
export default AddDeliveryAddressOffCanvas;
